import { render, staticRenderFns } from "./MdNote.vue?vue&type=template&id=6a3b7050&"
import script from "./MdNote.vue?vue&type=script&lang=js&"
export * from "./MdNote.vue?vue&type=script&lang=js&"
import style0 from "./MdNote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports